import { Navigate, Route, Routes } from 'react-router-dom';
import { useUserHasTableauAccess } from 'auth/lib/useUserHasTableauAccess';
import { Breadcrumb, PageHeader } from 'shared/ui';
import { links } from 'shared/constants';
import { Link } from '@mui/material';

import { RTIOverview } from './components/overview/RTIOverview';
import { RTIDashboard } from './components/dashboard/RTIDashboard';
import { RTISpecification } from './components/specifications/RTISpecification';

import { RoadTravelInsightsStyles } from './RoadTravelInsights.styles';
import headerImage from '../../assets/images/ai/header-image.png';

const RoadTravelInsights = () => {
  const hasTableauAccess = useUserHasTableauAccess();
  const menu = [
    { label: 'Product Overview', link: 'overview' },
    { label: 'Data Dashboard', link: 'dashboard' },
    { label: 'Specifications', link: 'specifications' },
  ];

  return (
    <RoadTravelInsightsStyles>
      <PageHeader image={headerImage} menus={menu}>
        <h1>{links.products.pages.roadInsights.label}</h1>
        <p>
          Road Insights provides insight into how travellers in <br /> the UK move across the road network.
        </p>
      </PageHeader>
      <Breadcrumb>
        <Link underline="none" color="inherit" href={links.about.link}>
          O<sub>2</sub> MOTION
        </Link>
        <Link underline="none" color="inherit" href={links.products.link}>
          {links.products.label.toUpperCase()}
        </Link>
        <Link underline="none" aria-current="page">
          {links.products.pages.roadInsights.label.toUpperCase()}
        </Link>
      </Breadcrumb>
      <Routes>
        <Route path="overview" element={<RTIOverview />} />
        <Route path="dashboard/*" element={<RTIDashboard hasTableauAccess={hasTableauAccess} />}></Route>
        <Route path="specifications" element={<RTISpecification />} />
        <Route path="" element={<Navigate to="overview" replace={true} />} />
      </Routes>
    </RoadTravelInsightsStyles>
  );
};

export default RoadTravelInsights;
